import customFetch from "../util/config/axiosConfig";
import { ApiResponse } from "../types/responseType";
import { toast } from "sonner";
import {
  CreateEventPayload,
  EventData,
  MonthlyEventsResponse,
} from "../types/eventType";
import { getErrorMessage } from "../util/functions/UniversalFunctions";

const CalendarAndEventApis = {
  //post
  createEvent: async (
    payload: CreateEventPayload,
  ): Promise<ApiResponse<EventData> | undefined> => {
    try {
      const response = await customFetch.post("/api/v1/events", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Error creating event:", error);
      toast.error(getErrorMessage(error) || "Failed to create event");
    }
  },

  // GET Monthly Events
  getMonthlyEvents: async (
    branchCode: string,
    yearMonth: string,
  ): Promise<ApiResponse<MonthlyEventsResponse> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/events/month`, {
        params: {
          branchCode,
          yearMonth,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Error fetching monthly events:", error);
      toast.error(getErrorMessage(error) || "Failed to load events");
    }
  },

  // GET Next Events
  getNextEvents: async (
    branchCode: string,
  ): Promise<ApiResponse<MonthlyEventsResponse> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/events/month`, {
        params: {
          branchCode,
        },
      });

      return response.data;
    } catch (error: any) {
      console.error("Error fetching Next events:", error);
      toast.error(getErrorMessage(error) || "Failed to load events");
    }
  },

  // by id
  getEventById: async (
    eventId: number | string,
  ): Promise<ApiResponse<EventData> | undefined> => {
    try {
      const response = await customFetch.get(`/api/v1/events/${eventId}`);
      return response.data;
    } catch (error: any) {
      console.error("Error fetching event details:", error);
      toast.error(getErrorMessage(error) || "Failed to load event details");
    }
  },

  updateEvent: async (
    eventId: number | string,
    payload: CreateEventPayload,
  ): Promise<ApiResponse<EventData> | undefined> => {
    try {
      const response = await customFetch.put(
        `/api/v1/events/${eventId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      return response.data;
    } catch (error: any) {
      console.error("Error updating event:", error);
      toast.error(getErrorMessage(error) || "Failed to update event");
    }
  },

  deleteEvent: async (
    eventId: number | string,
  ): Promise<ApiResponse<string> | undefined> => {
    try {
      const response = await customFetch.delete(`/api/v1/events/${eventId}`);

      return response.data;
    } catch (error: any) {
      console.error("Error deleting event:", error);
      toast.error(getErrorMessage(error) || "Failed to delete event");
    }
  },
};

export default CalendarAndEventApis;
